import { RuleProps } from 'types/application';

export const DEALER_LICENCE = 'dealer-licence';
export const DEALERS_CONTACT_PERSON_PARTICULARS = 'dealers-contact-person-particulars';
export const DEALERS_LICENCE_MAILING_ADDRESS = 'dealers-licence-mailing-address';
export const OTHER_DETAILS = 'other-details';
export const EQUIPMENT_DETAILS = 'equipment-details';
export const TECHNICAL_DATA_INFORMATION = 'technical-data-information';
export const EQUIPMENT_TECHNICAL_DATA_M2M = 'equipment-technical-data-m2m';
export const EQUIPMENT_TECHNICAL_DATA_RADIOCOM_INFO = 'equipment-technical-data-radiocom-info';
export const EQUIPMENT_TECHNICAL_DATA_RADIOCOM = 'equipment-technical-data-radiocom';
export const EQUIPMENT_TECHNICAL_DATA_RADIOCOM_4G_LTE = 'equipment-technical-data-radiocom-4g-lte';
export const EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_NSA = 'equipment-technical-data-radiocom-5g-nsa';
export const EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_SA = 'equipment-technical-data-radiocom-5g-sa';
export const EQUIPMENT_TECHNICAL_DATA_RADIOCOM_OTHERS = 'equipment-technical-data-radiocom-others';
export const EQUIPMENT_TECHNICAL_DATA_INTERNAL = 'equipment-technical-data-internal';

export const AMEND_SER_LICENCE = [
    {
        sectionID: DEALER_LICENCE,
        sectionName: '',
        fieldList: [
            {
                id: 'amend-table',
                label: ' ',
                type: 'table',
                subFields: [
                    {
                        id: 'type',
                        header: 'I want to amend',
                        type: 'text'
                    }
                ],
                span: 12
            },
            {
                id: 'dealer-licence-no',
                label: 'Dealer Licence No.',
                type: 'text',
                span: 12,
                rule: {
                    baseIds: [`${DEALER_LICENCE}-dealer-licence-no`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${DEALER_LICENCE}-dealer-licence-no`] === '-');
                        return result;
                    }
                }
            },
            {
                id: 'dealer-licence-company-name',
                label: "Dealer's Licence Company Name",
                type: 'text',
                span: 12,
                rule: {
                    baseIds: [`${DEALER_LICENCE}-dealer-licence-company-name`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${DEALER_LICENCE}-dealer-licence-company-name`] === '-');
                        return result;
                    }
                }
            },
            {
                id: 'scheme-type',
                label: 'Scheme Type',
                type: 'text',
                span: 12,
                rule: {
                    baseIds: [`${DEALER_LICENCE}-scheme-type`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${DEALER_LICENCE}-scheme-type`] === '-');
                        return result;
                    }
                }
            }
        ]
    },
    {
        sectionID: DEALERS_CONTACT_PERSON_PARTICULARS,
        sectionName: 'Dealer Contact Person Particulars',
        fieldList: [
            {
                id: 'same-as-applicant-particulars',
                label: 'Same as Applicant Particulars',
                type: 'text',
                span: 12,
                rule: {
                    baseIds: [`${DEALERS_CONTACT_PERSON_PARTICULARS}-same-as-applicant-particulars`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(
                            baseValues && baseValues[`${DEALERS_CONTACT_PERSON_PARTICULARS}-same-as-applicant-particulars`] === '-'
                        );
                        return result;
                    }
                }
            },
            {
                id: 'name',
                label: 'Name',
                type: 'text',
                rule: {
                    baseIds: [`${DEALERS_CONTACT_PERSON_PARTICULARS}-name`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${DEALERS_CONTACT_PERSON_PARTICULARS}-name`] === '-');
                        return result;
                    }
                }
            },
            {
                id: 'designation',
                label: 'Designation',
                type: 'text',
                rule: {
                    baseIds: [`${DEALERS_CONTACT_PERSON_PARTICULARS}-designation`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${DEALERS_CONTACT_PERSON_PARTICULARS}-designation`] === '-');
                        return result;
                    }
                }
            },
            {
                id: 'email',
                label: 'Email',
                type: 'text',
                rule: {
                    baseIds: [`${DEALERS_CONTACT_PERSON_PARTICULARS}-email`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${DEALERS_CONTACT_PERSON_PARTICULARS}-email`] === '-');
                        return result;
                    }
                }
            },
            {
                id: 'office-tel-number',
                label: 'Office Tel Number',
                type: 'text',
                rule: {
                    baseIds: [`${DEALERS_CONTACT_PERSON_PARTICULARS}-office-tel-number`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${DEALERS_CONTACT_PERSON_PARTICULARS}-office-tel-number`] === '-');
                        return result;
                    }
                }
            },
            {
                id: 'mobile-number',
                label: 'Mobile Number',
                type: 'text',
                rule: {
                    baseIds: [`${DEALERS_CONTACT_PERSON_PARTICULARS}-mobile-number`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${DEALERS_CONTACT_PERSON_PARTICULARS}-mobile-number`] === '-');
                        return result;
                    }
                }
            },
            {
                id: 'fax-number',
                label: 'Fax Number',
                type: 'text',
                rule: {
                    baseIds: [`${DEALERS_CONTACT_PERSON_PARTICULARS}-fax-number`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${DEALERS_CONTACT_PERSON_PARTICULARS}-fax-number`] === '-');
                        return result;
                    }
                }
            }
        ]
    },
    {
        sectionID: DEALERS_LICENCE_MAILING_ADDRESS,
        sectionName: "Dealer's Licence Mailing Address",
        fieldList: [
            {
                id: 'same-as-applicant-particulars',
                label: 'Same as Applicant Particulars',
                type: 'text',
                span: 12,
                rule: {
                    baseIds: [`${DEALERS_LICENCE_MAILING_ADDRESS}-same-as-applicant-particulars`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(
                            baseValues && baseValues[`${DEALERS_LICENCE_MAILING_ADDRESS}-same-as-applicant-particulars`] === '-'
                        );
                        return result;
                    }
                }
            },
            {
                id: 'building-name',
                label: 'Building Name',
                type: 'text',
                rule: {
                    baseIds: [`${DEALERS_LICENCE_MAILING_ADDRESS}-building-name`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${DEALERS_LICENCE_MAILING_ADDRESS}-building-name`] === '-');
                        return result;
                    }
                }
            },
            {
                id: 'postal-code',
                label: 'Postal Code',
                type: 'text',
                rule: {
                    baseIds: [`${DEALERS_LICENCE_MAILING_ADDRESS}-postal-code`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${DEALERS_LICENCE_MAILING_ADDRESS}-postal-code`] === '-');
                        return result;
                    }
                }
            },
            {
                id: 'street-name',
                label: 'Street Name',
                type: 'text',
                rule: {
                    baseIds: [`${DEALERS_LICENCE_MAILING_ADDRESS}-street-name`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${DEALERS_LICENCE_MAILING_ADDRESS}-street-name`] === '-');
                        return result;
                    }
                }
            },
            {
                id: 'block-house-no',
                label: 'Block/House No.',
                type: 'text',
                rule: {
                    baseIds: [`${DEALERS_LICENCE_MAILING_ADDRESS}-block-house-no`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${DEALERS_LICENCE_MAILING_ADDRESS}-block-house-no`] === '-');
                        return result;
                    }
                }
            },
            {
                id: 'floor-level',
                label: 'Floor/Level (Optional)',
                type: 'text',
                rule: {
                    baseIds: [`${DEALERS_LICENCE_MAILING_ADDRESS}-floor-level`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${DEALERS_LICENCE_MAILING_ADDRESS}-floor-level`] === '-');
                        return result;
                    }
                }
            },
            {
                id: 'unit',
                label: 'Unit (Optional)',
                type: 'text',
                rule: {
                    baseIds: [`${DEALERS_LICENCE_MAILING_ADDRESS}-unit`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${DEALERS_LICENCE_MAILING_ADDRESS}-unit`] === '-');
                        return result;
                    }
                }
            }
        ]
    },
    {
        sectionID: OTHER_DETAILS,
        sectionName: 'Other Details',
        fieldList: [
            {
                id: 'other-details',
                label: '',
                type: 'text',
                span: 12,
                rule: {
                    hidden: true
                }
            },
            {
                id: 'public-contact-no',
                label: 'Public Contact No.',
                type: 'text',
                span: 12,
                rule: {
                    baseIds: [`${OTHER_DETAILS}-public-contact-no`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${OTHER_DETAILS}-public-contact-no`] === '-');
                        return result;
                    }
                }
            },
            {
                id: 'remarks',
                label: 'Remarks',
                type: 'text',
                span: 12,
                rule: {
                    baseIds: [`${OTHER_DETAILS}-remarks`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${OTHER_DETAILS}-remarks`] === '-');
                        return result;
                    }
                }
            }
        ],
        rule: {
            baseIds: [`${OTHER_DETAILS}-other-details`],
            hidden: ({ baseValues }: RuleProps) => {
                const value: any = baseValues && baseValues[`${OTHER_DETAILS}-other-details`];
                const result = Boolean((Object.keys(value).length === 1 && Object.keys(value).includes('pxObjClass')) || value === '-');
                return result;
            }
        }
    },
    {
        sectionID: EQUIPMENT_DETAILS,
        sectionName: 'Equipment Details',
        fieldList: [
            {
                id: 'ser-scheme-equipment-type',
                label: 'Equipment Types that shall be registered under the SER scheme',
                type: 'lists',
                span: 12,
                rule: {
                    baseIds: [`${EQUIPMENT_DETAILS}-ser-scheme-equipment-type`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const value: any = baseValues && baseValues[`${EQUIPMENT_DETAILS}-ser-scheme-equipment-type`];
                        const result = Boolean(value.length === 0);
                        return result;
                    }
                }
            },
            {
                id: 'mandatory-imda-spec-no-desc',
                label: 'Mandatory IMDA Spec No/Desc',
                type: 'lists',
                span: 12,
                rule: {
                    baseIds: [`${EQUIPMENT_DETAILS}-mandatory-imda-spec-no-desc`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const value: any = baseValues && baseValues[`${EQUIPMENT_DETAILS}-mandatory-imda-spec-no-desc`];
                        const result = Boolean(value.length === 0);
                        return result;
                    }
                }
            },
            {
                id: 'optional-imda-spec-no-desc',
                label: 'Optional IMDA Spec No/Desc',
                type: 'lists',
                span: 12,
                rule: {
                    baseIds: [`${EQUIPMENT_DETAILS}-optional-imda-spec-no-desc`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const value: any = baseValues && baseValues[`${EQUIPMENT_DETAILS}-optional-imda-spec-no-desc`];
                        const result = Boolean(value.length === 0);
                        return result;
                    }
                }
            },
            {
                id: 'review-and-confirmed-tech-spec',
                label: 'I/We have reviewed and confirmed that the Technical Specification for Security Requirements to Guard against Network Storms for Celullar Devices (IMDA TS CD-SEC) is not applicable to the above cellular device',
                type: 'text',
                span: 12,
                rule: {
                    baseIds: [`${EQUIPMENT_DETAILS}-review-and-confirmed-tech-spec`, `${EQUIPMENT_DETAILS}-ser-scheme-equipment-type`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const reviewConfirmedTechSpec = Boolean(
                            baseValues && baseValues[`${EQUIPMENT_DETAILS}-review-and-confirmed-tech-spec`] === '-'
                        );
                        const serSchemeEquipmentType: any = baseValues && baseValues[`${EQUIPMENT_DETAILS}-ser-scheme-equipment-type`];

                        const result = !Boolean(
                            !reviewConfirmedTechSpec &&
                                (serSchemeEquipmentType.includes('M2M - Overseas SIM') ||
                                    serSchemeEquipmentType.includes('M2M - Local SIM') ||
                                    serSchemeEquipmentType.includes('Mobile Terminals'))
                        );
                        return result;
                    }
                }
            },
            {
                id: 'equipment-description',
                label: 'Equipment Description',
                type: 'text',
                rule: {
                    baseIds: [`${EQUIPMENT_DETAILS}-equipment-description`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${EQUIPMENT_DETAILS}-equipment-description`] === '-');
                        return result;
                    }
                }
            },
            {
                id: 'brand-trade-name',
                label: 'Brand/Trade Name',
                type: 'text',
                rule: {
                    baseIds: [`${EQUIPMENT_DETAILS}-brand-trade-name`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${EQUIPMENT_DETAILS}-brand-trade-name`] === '-');
                        return result;
                    }
                }
            },
            {
                id: 'model-no',
                label: 'Model No',
                type: 'text',
                rule: {
                    baseIds: [`${EQUIPMENT_DETAILS}-model-no`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${EQUIPMENT_DETAILS}-model-no`] === '-');
                        return result;
                    }
                }
            },
            {
                id: 'marketing-name',
                label: 'Marketing Name',
                type: 'text',
                rule: {
                    baseIds: [`${EQUIPMENT_DETAILS}-marketing-name`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${EQUIPMENT_DETAILS}-marketing-name`] === '-');
                        return result;
                    }
                }
            },
            {
                id: 'manufacturer-name',
                label: 'Manufacturer Name (Country)',
                type: 'text',
                rule: {
                    baseIds: [`${EQUIPMENT_DETAILS}-manufacturer-name`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${EQUIPMENT_DETAILS}-manufacturer-name`] === '-');
                        return result;
                    }
                }
            },
            {
                id: 'country-of-origin',
                label: 'Country of Origin/Import Country',
                type: 'text',
                rule: {
                    baseIds: [`${EQUIPMENT_DETAILS}-country-of-origin`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${EQUIPMENT_DETAILS}-country-of-origin`] === '-');
                        return result;
                    }
                }
            },
            {
                id: 'fee',
                label: 'Fee',
                type: 'text',
                rule: {
                    baseIds: [`${EQUIPMENT_DETAILS}-fee`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${EQUIPMENT_DETAILS}-fee`] === '-');
                        return result;
                    }
                }
            },
            {
                id: 'network-connection',
                label: 'Network Connection',
                type: 'lists',
                span: 12,
                rule: {
                    baseIds: [`${EQUIPMENT_DETAILS}-network-connection`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const value: any = baseValues && baseValues[`${EQUIPMENT_DETAILS}-network-connection`];
                        const result = Boolean(value.length === 0);
                        return result;
                    }
                }
            }
        ]
    },
    {
        sectionID: TECHNICAL_DATA_INFORMATION,
        sectionName: 'Technical Information',
        fieldList: [
            {
                id: 'test-lab-name',
                label: 'Test Lab Name',
                type: 'text',
                rule: {
                    baseIds: [`${TECHNICAL_DATA_INFORMATION}-test-lab-name`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${TECHNICAL_DATA_INFORMATION}-test-lab-name`] === '-');
                        return result;
                    }
                }
            },
            {
                id: 'test-report-no',
                label: 'Test Report No',
                type: 'text',
                rule: {
                    baseIds: [`${TECHNICAL_DATA_INFORMATION}-test-report-no`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${TECHNICAL_DATA_INFORMATION}-test-report-no`] === '-');
                        return result;
                    }
                }
            },
            {
                id: 'country-of-lab',
                label: 'Country of Lab',
                type: 'text',
                rule: {
                    baseIds: [`${TECHNICAL_DATA_INFORMATION}-country-of-lab`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${TECHNICAL_DATA_INFORMATION}-country-of-lab`] === '-');
                        return result;
                    }
                }
            },
            {
                id: 'applied-for',
                label: 'Applied For',
                type: 'lists',
                span: 12,
                rule: {
                    baseIds: [`${TECHNICAL_DATA_INFORMATION}-applied-for`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const value: any = baseValues && baseValues[`${TECHNICAL_DATA_INFORMATION}-applied-for`];
                        const result = Boolean(value.length === 0);
                        return result;
                    }
                }
            }
        ]
    },
    {
        sectionID: EQUIPMENT_TECHNICAL_DATA_M2M,
        sectionName: 'Equipment Technical Data - M2M',
        fieldList: [
            {
                id: 'sim-card-provider',
                label: 'Sim Card Provider',
                type: 'text'
            },
            {
                id: 'm2m-service-provider',
                label: 'M2M Service Provider',
                type: 'text'
            },
            {
                id: 'projected-use-life-of-equipment',
                label: 'Projected Use Life of Equipment',
                type: 'text'
            },
            {
                id: 'purposes-services-and-type-of-information',
                label: 'Purposes/services and type of information Describe the purposes/services and type of information being monitored/transmitted and the intented recipient party',
                type: 'text'
            }
        ],
        rule: {
            baseIds: [`${TECHNICAL_DATA_INFORMATION}-applied-for`],
            hidden: ({ baseValues }: RuleProps) => {
                const value: any = baseValues && baseValues[`${TECHNICAL_DATA_INFORMATION}-applied-for`];
                const result = !Boolean(value.includes('M2M'));
                return result;
            }
        }
    },
    {
        sectionID: EQUIPMENT_TECHNICAL_DATA_RADIOCOM_INFO,
        sectionName: 'Equipment Technical Data - Radiocom info',
        fieldList: [
            {
                id: 'channel-spacing',
                label: 'Channel Spacing (Optional)',
                type: 'text'
            },
            {
                id: 'sar-value-w-kg',
                label: 'SAR Value W/kg @ 10g (Optional) (Mandatory for Mobile Phone)',
                type: 'text'
            }
        ],
        rule: {
            baseIds: [`${TECHNICAL_DATA_INFORMATION}-applied-for`],
            hidden: ({ baseValues }: RuleProps) => {
                const value: any = baseValues && baseValues[`${TECHNICAL_DATA_INFORMATION}-applied-for`];
                const result = !Boolean(value.includes('Radiocom') || value.includes('M2M'));
                return result;
            }
        }
    },
    {
        sectionID: EQUIPMENT_TECHNICAL_DATA_RADIOCOM,
        sectionName: 'Equipment Technical Data - Radiocom',
        fieldList: [
            {
                id: 'please-select-technology',
                label: 'Please Select Technology',
                type: 'lists',
                span: 12
            }
        ],
        rule: {
            baseIds: [`${TECHNICAL_DATA_INFORMATION}-applied-for`],
            hidden: ({ baseValues }: RuleProps) => {
                const value: any = baseValues && baseValues[`${TECHNICAL_DATA_INFORMATION}-applied-for`];
                const result = !Boolean(value.includes('Radiocom') || value.includes('M2M'));
                return result;
            }
        }
    },
    {
        sectionID: EQUIPMENT_TECHNICAL_DATA_RADIOCOM_4G_LTE,
        sectionName: 'Equipment Technical Data - Radiocom (4G/LTE)',
        fieldList: [
            {
                id: 'does-the-equipment-support-b1',
                label: 'Does the equipment support B1 (1920 - 1980 MHz / 2110 - 2170 MHz) Frequency Band?',
                type: 'text',
                span: 12
            },
            {
                id: 'does-the-equipment-support-b3',
                label: 'Does the equipment support B3 (1710 - 1785 MHz / 1805 - 1880 MHz) Frequency Band?',
                type: 'text',
                span: 12
            },
            {
                id: 'does-the-equipment-support-b7',
                label: 'Does the equipment support B7 (2500 - 2570 MHz / 2620 - 2690 MHz) Frequency Band?',
                type: 'text',
                span: 12
            },
            {
                id: 'does-the-equipment-support-b8',
                label: 'Does the equipment support B8 (880 - 915 MHz / 925 - 960 MHz) Frequency Band?',
                type: 'text',
                span: 12
            },
            {
                id: 'does-the-equipment-support-b26',
                label: 'Does the equipment support B26 (814 - 849 MHz / 859 - 894 MHz) Frequency Band?',
                type: 'text',
                span: 12
            },
            {
                id: 'does-the-equipment-support-b28',
                label: 'Does the equipment support B28 (703 - 748 MHz / 754 - 803 MHz) Frequency Band?',
                type: 'text',
                span: 12
            },
            {
                id: 'does-the-equipment-support-b38',
                label: 'Does the equipment support B38 (2570 - 2620 MHz TDD) Frequency Band?',
                type: 'text',
                span: 12
            },
            {
                id: 'does-the-equipment-support-b40',
                label: 'Does the equipment support B40 (2300 - 2400 MHz TDD) Frequency Band?',
                type: 'text',
                span: 12
            }
        ],
        rule: {
            baseIds: [`${TECHNICAL_DATA_INFORMATION}-applied-for`, `${EQUIPMENT_TECHNICAL_DATA_RADIOCOM}-please-select-technology`],
            hidden: ({ baseValues }: RuleProps) => {
                const applyFor: any = baseValues && baseValues[`${TECHNICAL_DATA_INFORMATION}-applied-for`];
                const technology: any = baseValues && baseValues[`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM}-please-select-technology`];
                const result = !Boolean((applyFor.includes('Radiocom') || applyFor.includes('M2M')) && technology.includes('4G/LTE'));
                return result;
            }
        }
    },
    {
        sectionID: EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_NSA,
        sectionName: 'Equipment Technical Data - Radiocom (5G NSA)',
        fieldList: [
            {
                id: 'does-the-equipment-support-n1',
                label: 'Does the equipment support n1 (1920 - 1980 MHz / 2110 - 2170 MHz) Frequency Band?',
                type: 'text',
                span: 12
            },
            {
                id: 'please-indicate-power-class-for-n1',
                label: 'Please indicate power class for n1',
                type: 'text',
                span: 12
            },
            {
                id: 'does-the-equipment-support-n3',
                label: 'Does the equipment support n3 (1710 - 1785 MHz / 1805 - 1880 MHz) Frequency Band?',
                type: 'text',
                span: 12
            },
            {
                id: 'please-indicate-power-class-for-n3',
                label: 'Please indicate power class for n3',
                type: 'text',
                span: 12
            },
            {
                id: 'does-the-equipment-support-n7',
                label: 'Does the equipment support n7 (2500 - 2570 MHz / 2620 - 2690 MHz) Frequency Band?',
                type: 'text',
                span: 12
            },
            {
                id: 'please-indicate-power-class-for-n7',
                label: 'Please indicate power class for n7',
                type: 'text',
                span: 12
            },
            {
                id: 'does-the-equipment-support-n8',
                label: 'Does the equipment support n8 (880 - 915 MHz / 925 - 960 MHz) Frequency Band?',
                type: 'text',
                span: 12
            },
            {
                id: 'please-indicate-power-class-for-n8',
                label: 'Please indicate power class for n8',
                type: 'text',
                span: 12
            },
            {
                id: 'does-the-equipment-support-n26',
                label: 'Does the equipment support n26 (814 - 849 MHz / 859 - 894 MHz) Frequency Band?',
                type: 'text',
                span: 12,
            },
            {
                id: 'please-indicate-power-class-for-n26',
                label: 'Please indicate power class for n26:',
                type: 'text',
                span: 12,
                rule: {
                    baseIds: [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_NSA}-does-the-equipment-support-n26`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const value = baseValues?.[`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_NSA}-does-the-equipment-support-n26`];
                        return value === '-';
                    }
                }
            },
            {
                id: 'does-the-equipment-support-n28',
                label: 'Does the equipment support n28 (703 - 748 MHz / 754 - 803 MHz) Frequency Band?',
                type: 'text',
                span: 12
            },
            {
                id: 'please-indicate-power-class-for-n28',
                label: 'Please indicate power class for n28:',
                type: 'text',
                span: 12,
                rule: {
                    baseIds: [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_NSA}-does-the-equipment-support-n28`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const value = baseValues?.[`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_NSA}-does-the-equipment-support-n28`];
                        return value === '-';
                    }
                }
            },
            {
                id: 'does-the-equipment-support-n38',
                label: 'Does the equipment support n38 (2570 - 2620 MHz TDD) Frequency Band?',
                type: 'text',
                span: 12
            },
            {
                id: 'please-indicate-power-class-for-n38',
                label: 'Please indicate power class for n38',
                type: 'text',
                span: 12
            },
            {
                id: 'does-the-equipment-support-n40',
                label: 'Does the equipment support n40 (2300 - 2400 MHz TDD) Frequency Band?',
                type: 'text',
                span: 12
            },
            {
                id: 'please-indicate-power-class-for-n40',
                label: 'Please indicate power class for n40',
                type: 'text',
                span: 12
            },
            {
                id: 'does-the-equipment-support-n77',
                label: 'Does the equipment support n77 (3300 - 4200 MHz TDD) Frequency Band?',
                type: 'text',
                span: 12
            },
            {
                id: 'please-indicate-power-class-for-n77',
                label: 'Please indicate power class for n77',
                type: 'text',
                span: 12
            },
            {
                id: 'does-the-equipment-support-n78',
                label: 'Does the equipment support n78 (3300 - 3800 MHz TDD) Frequency Band?',
                type: 'text',
                span: 12
            },
            {
                id: 'please-indicate-power-class-for-n78',
                label: 'Please indicate power class for n78',
                type: 'text',
                span: 12
            },
            {
                id: 'does-the-equipment-support-n257',
                label: 'Does the equipment support n257 (26500 - 29500 MHz TDD) Frequency Band?',
                type: 'text',
                span: 12
            },
            {
                id: 'please-indicate-power-class-for-n257',
                label: 'Please indicate power class for n257',
                type: 'text',
                span: 12
            },
            {
                id: 'does-the-equipment-support-n258',
                label: 'Does the equipment support n258 (24250 - 27500 MHz TDD) Frequency Band?',
                type: 'text',
                span: 12
            },
            {
                id: 'please-indicate-power-class-for-n258',
                label: 'Please indicate power class for n258',
                type: 'text',
                span: 12
            },
            {
                id: 'does-the-equipment-support-n261',
                label: 'Does the equipment support n261 (27500 - 28350 MHz TDD) Frequency Band?',
                type: 'text',
                span: 12
            },
            {
                id: 'please-indicate-power-class-for-n261',
                label: 'Please indicate power class for n261',
                type: 'text',
                span: 12
            }
        ],
        rule: {
            baseIds: [`${TECHNICAL_DATA_INFORMATION}-applied-for`, `${EQUIPMENT_TECHNICAL_DATA_RADIOCOM}-please-select-technology`],
            hidden: ({ baseValues }: RuleProps) => {
                const applyFor: any = baseValues && baseValues[`${TECHNICAL_DATA_INFORMATION}-applied-for`];
                const technology: any = baseValues && baseValues[`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM}-please-select-technology`];
                const result = !Boolean((applyFor.includes('Radiocom') || applyFor.includes('M2M')) && technology.includes('5G NSA'));
                return result;
            }
        }
    },
    {
        sectionID: EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_SA,
        sectionName: 'Equipment Technical Data - Radiocom (5G SA)',
        fieldList: [
            {
                id: 'does-the-equipment-support-n1',
                label: 'Does the equipment support n1 (1920 - 1980 MHz / 2110 - 2170 MHz) Frequency Band?',
                type: 'text',
                span: 12
            },
            {
                id: 'please-indicate-power-class-for-n1',
                label: 'Please indicate power class for n1',
                type: 'text',
                span: 12
            },
            {
                id: 'does-the-equipment-support-n3',
                label: 'Does the equipment support n3 (1710 - 1785 MHz / 1805 - 1880 MHz) Frequency Band?',
                type: 'text',
                span: 12
            },
            {
                id: 'please-indicate-power-class-for-n3',
                label: 'Please indicate power class for n3',
                type: 'text',
                span: 12
            },
            {
                id: 'does-the-equipment-support-n7',
                label: 'Does the equipment support n7 (2500 - 2570 MHz / 2620 - 2690 MHz) Frequency Band?',
                type: 'text',
                span: 12
            },
            {
                id: 'please-indicate-power-class-for-n7',
                label: 'Please indicate power class for n7',
                type: 'text',
                span: 12
            },
            {
                id: 'does-the-equipment-support-n8',
                label: 'Does the equipment support n8 (880 - 915 MHz / 925 - 960 MHz) Frequency Band?',
                type: 'text',
                span: 12
            },
            {
                id: 'please-indicate-power-class-for-n8',
                label: 'Please indicate power class for n8',
                type: 'text',
                span: 12
            },
            {
                id: 'does-the-equipment-support-n26',
                label: 'Does the equipment support n26 (814 - 849 MHz / 859 - 894 MHz) Frequency Band?',
                type: 'text',
                span: 12,
            },
            {
                id: 'please-indicate-power-class-for-n26',
                label: 'Please indicate power class for n26:',
                type: 'text',
                span: 12,
                rule: {
                    baseIds: [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_SA}-does-the-equipment-support-n26`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const value = baseValues?.[`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_SA}-does-the-equipment-support-n26`];
                        return value === '-';
                    }
                }
            },
            {
                id: 'does-the-equipment-support-n28',
                label: 'Does the equipment support n28 (703 - 748 MHz / 754 - 803 MHz) Frequency Band?',
                type: 'text',
                span: 12
            },
            {
                id: 'please-indicate-power-class-for-n28',
                label: 'Please indicate power class for n28:',
                type: 'text',
                span: 12,
                rule: {
                    baseIds: [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_SA}-does-the-equipment-support-n28`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const value = baseValues?.[`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_SA}-does-the-equipment-support-n28`];
                        return value === '-';
                    }
                }
            },
            {
                id: 'does-the-equipment-support-n38',
                label: 'Does the equipment support n38 (2570 - 2620 MHz TDD) Frequency Band?',
                type: 'text',
                span: 12
            },
            {
                id: 'please-indicate-power-class-for-n38',
                label: 'Please indicate power class for n38',
                type: 'text',
                span: 12
            },
            {
                id: 'does-the-equipment-support-n40',
                label: 'Does the equipment support n40 (2300 - 2400 MHz TDD) Frequency Band?',
                type: 'text',
                span: 12
            },
            {
                id: 'please-indicate-power-class-for-n40',
                label: 'Please indicate power class for n40',
                type: 'text',
                span: 12
            },
            {
                id: 'does-the-equipment-support-n77',
                label: 'Does the equipment support n77 (3300 - 4200 MHz TDD) Frequency Band?',
                type: 'text',
                span: 12
            },
            {
                id: 'please-indicate-power-class-for-n77',
                label: 'Please indicate power class for n77',
                type: 'text',
                span: 12
            },
            {
                id: 'does-the-equipment-support-n78',
                label: 'Does the equipment support n78 (3300 - 3800 MHz TDD) Frequency Band?',
                type: 'text',
                span: 12
            },
            {
                id: 'please-indicate-power-class-for-n78',
                label: 'Please indicate power class for n78',
                type: 'text',
                span: 12
            },
            {
                id: 'does-the-equipment-support-n257',
                label: 'Does the equipment support n257 (26500 - 29500 MHz TDD) Frequency Band?',
                type: 'text',
                span: 12
            },
            {
                id: 'please-indicate-power-class-for-n257',
                label: 'Please indicate power class for n257',
                type: 'text',
                span: 12
            },
            {
                id: 'does-the-equipment-support-n258',
                label: 'Does the equipment support n258 (24250 - 27500 MHz TDD) Frequency Band?',
                type: 'text',
                span: 12
            },
            {
                id: 'please-indicate-power-class-for-n258',
                label: 'Please indicate power class for n258',
                type: 'text',
                span: 12
            },
            {
                id: 'does-the-equipment-support-n261',
                label: 'Does the equipment support n261 (27500 - 28350 MHz TDD) Frequency Band?',
                type: 'text',
                span: 12
            },
            {
                id: 'please-indicate-power-class-for-n261',
                label: 'Please indicate power class for n261',
                type: 'text',
                span: 12
            }
        ],
        rule: {
            baseIds: [`${TECHNICAL_DATA_INFORMATION}-applied-for`, `${EQUIPMENT_TECHNICAL_DATA_RADIOCOM}-please-select-technology`],
            hidden: ({ baseValues }: RuleProps) => {
                const applyFor: any = baseValues && baseValues[`${TECHNICAL_DATA_INFORMATION}-applied-for`];
                const technology: any = baseValues && baseValues[`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM}-please-select-technology`];
                const result = !Boolean((applyFor.includes('Radiocom') || applyFor.includes('M2M')) && technology.includes('5G SA'));
                return result;
            }
        }
    },
    {
        sectionID: EQUIPMENT_TECHNICAL_DATA_RADIOCOM_OTHERS,
        sectionName: 'Equipment Technical Data - Radiocom - Others',
        fieldList: [
            {
                id: 'equipment-technical-data-radiocom-others',
                label: '',
                type: 'table2',
                subFields: [
                    {
                        id: 'row-id',
                        header: '',
                        type: 'text'
                    },
                    {
                        id: 'tx-freq-range',
                        header: 'TX Freq Range',
                        type: 'text'
                    },
                    {
                        id: 'rx-freq-range',
                        header: 'RX Freq Range',
                        type: 'text'
                    },
                    {
                        id: 'rf-power-output',
                        header: 'RF Power Output',
                        type: 'text'
                    }
                ],
                span: 12
            }
        ],
        rule: {
            baseIds: [`${TECHNICAL_DATA_INFORMATION}-applied-for`, `${EQUIPMENT_TECHNICAL_DATA_RADIOCOM}-please-select-technology`],
            hidden: ({ baseValues }: RuleProps) => {
                const applyFor: any = baseValues && baseValues[`${TECHNICAL_DATA_INFORMATION}-applied-for`];
                const technology: any = baseValues && baseValues[`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM}-please-select-technology`];
                const result = !Boolean(
                    (applyFor.includes('Radiocom') || applyFor.includes('M2M')) && technology.includes('Others (e.g. GMPCS)')
                );
                return result;
            }
        }
    },
    {
        sectionID: EQUIPMENT_TECHNICAL_DATA_INTERNAL,
        sectionName: 'Equipment Technical Data - Internal',
        fieldList: [
            {
                id: 'equipment-technical-data-internal',
                label: '',
                type: 'table2',
                subFields: [
                    {
                        id: 'row-id',
                        header: '',
                        type: 'text'
                    },
                    {
                        id: 'capability',
                        header: 'Capability',
                        type: 'text'
                    },
                    {
                        id: 'tx-freq-range',
                        header: 'TX Freq Range',
                        type: 'text'
                    },
                    {
                        id: 'rx-freq-range',
                        header: 'RX Freq Range',
                        type: 'text'
                    },
                    {
                        id: 'rf-power-output',
                        header: 'RF Power Output',
                        type: 'text'
                    },
                    {
                        id: 'comments',
                        header: 'Comments',
                        type: 'text'
                    }
                ],
                span: 12
            }
        ],
        rule: {
            baseIds: [`${EQUIPMENT_TECHNICAL_DATA_INTERNAL}-list`],
            hidden: ({ baseValues }: RuleProps) => {
                const value = baseValues?.[`${EQUIPMENT_TECHNICAL_DATA_INTERNAL}-list`];
                console.log(value)
                return !Array.isArray(value) || value.length === 0;
            }
        }
    }
];
